import React from 'react'
import { useGetCart } from '../CartQuery/CartQuery'
import { Notification } from '../Notification/Notification'

const NOT_IN_DELIVERY_AREA = 'NOT_IN_DELIVERY_AREA'

export const CartNotifications = () => {
  let { info, warnings } = useGetCart()
  info = info || []
  warnings = (warnings || []).filter(
    ({ code }) => code !== NOT_IN_DELIVERY_AREA
  )
  return (
    <React.Fragment>
      {info.map(info => (
        <Notification key={info.code} isCloseable>
          {info.message}
        </Notification>
      ))}
      {warnings.map(warning => (
        <Notification key={warning.code} isCloseable severity='warning'>
          {warning.message}
        </Notification>
      ))}
    </React.Fragment>
  )
}
